(function() {
	/**
	 * @exports DKA.controllers.home
	 * @requires HBS
	 */
	let module = {};

	module.init = () => {
		console.log('literature.js initialized!!');
	 	 
		module.setupDropdowns();				
	}; 



	module.setupDropdowns  = () =>  {
		
		//event listener for product type change
		// var categorySelectObj = document.getElementById('category_select');
		// var categoryLabel = document.getElementById('category_label');
		var seriesSelectObj = document.getElementById('series_select');
		var seriesLabel = document.getElementById('series_label');
  		var productType = document.getElementById("product_type_select");
  		var resetDD = "<option selected value> -- select an option -- </option>";
  		var categories = [];

		productType.addEventListener("change", handleProductChange);
		// categorySelectObj.addEventListener("change", handleCategoryChange);

		function handleProductChange(){  			
			
			console.log('the product changed to ' + productType.value);

			// reset our series drop down
			// seriesSelectObj.disabled = true;
			// seriesSelectObj.innerHTML = resetDD;
			// seriesLabel.classList.add("disabled");

			if (productType.value){
				// populate the product drop down by product collection
				// get the data
				console.log(encodeURIComponent(productType.value));
				fetch('/wp-json/products/v1/literature?collectionID=' + encodeURIComponent(productType.value))
					.then(response => response.json())
					.then(data => {

						var seriesSelect = resetDD;
						var series = '';
						let seriesList = data;
 

						seriesList.forEach(function(series) {
							console.log(series['product_name']);
							seriesSelect += "<option value='" +  + series['product_id'] + "'>" + series['product_name'] + "</option>"				 
						});

						//removed disabled class from drop down label
						seriesLabel.classList.remove("disabled");
						// update DOM with new series select contents
						seriesSelectObj.innerHTML = seriesSelect;
						// remove the disabled state from the series drop down
	  					seriesSelectObj.disabled = false;
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			} else {
				// make sure category and series drop downs are disabled
				// categorySelectObj.disabled = true;
				// seriesSelectObj.disabled = true; 
				// categorySelectObj.innerHTML = resetDD;
				// seriesSelectObj.innerHTML = resetDD;
				// categoryLabel.classList.add("disabled");
				// seriesLabel.classList.add("disabled");
			}
		}

		function handleCategoryChange(){  			
			
			console.log('the category changed to ' + categorySelectObj.value);

			if (categorySelectObj.value){
				// populate the series drop down by product type
				// get the data
				fetch('/wp-json/series/v1/by_category?id=' + encodeURIComponent(productType.value) + '&category=' + encodeURIComponent(categorySelectObj.value))
					.then(response => response.json())
					.then(data => {
						console.log(data);

						var seriesSelect = resetDD;
						var series = '';
						let seriesList = data[0].series;

						console.log(seriesList);

						seriesList.forEach(function(series) {
							console.log(series);
							seriesSelect += "<option>" + series + "</option>"				 
						});

						//removed disabled class from drop down label
						seriesLabel.classList.remove("disabled");
						// update DOM with new series select contents
						seriesSelectObj.innerHTML = seriesSelect;
						// remove the disabled state from the series drop down
	  					seriesSelectObj.disabled = false;
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			} else {
				// make sure series is disabled
				seriesSelectObj.disabled = true;
				seriesSelectObj.innerHTML = resetDD;				
				seriesLabel.classList.add("disabled");
			}
		}
  
	};

	var docReady = function docReady(callback) {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
		// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
		// IE <= 8
			document.attachEvent('onreadystatechange', function () {
				if (document.readyState === 'complete') callback();
			});
		}
	};
	
	docReady(() => {
		module.init(); 
	});

	HBS.namespace('DKA.controllers.literature', module);
}());